import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  href,
  children,
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block bg-gradient-to-r from-[#16a34a] to-[#22c55e] text-white font-black text-xl md:text-2xl py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(22,163,74,0.4)] animate-pulse hover:animate-none text-center transition-all ${className}`} data-id="element-175">
      {children}
    </motion.a>;
}